import api from "../../utils/api";

export const useChangePassword = async (password) => {
  await api.put("auth/changepassword", { password });
};
